import { createContext } from 'react';

export const BrandedHeaderMenuContainerContext =
  createContext<HTMLElement | null>(null);
